import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderSummaryPriceInfoComponent } from './order-summary-price-info.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [OrderSummaryPriceInfoComponent],
  imports: [CommonModule, TranslocoModule],
  exports: [OrderSummaryPriceInfoComponent],
})
export class OrderSummaryPriceInfoModule {}
